import BasicButton from "components/BasicInputs/BasicButton";
import { useFormikContext } from "formik";
import { formatPrice } from "helpers";
import useCurrency from "helpers/useCurrency";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import { installmentSchema } from "../validation";
import { appSetAlert } from "../../../store/actions/appAction";
import { apiSaveInstallment, apiUpdateInstallment } from "api/installmentApi";
import PrintInstallMent from "../Print/PrintInstallMent";
import { useState } from "react";

type ServerDataProps = {
  description: string;
  prepayment?: number;
  profit?: number;
  quantity: number;
  interval?: number;
  totalPaid: number;
  lateFeesRate?: number;
  LateFeesDay?: number;
  LateFeesRateType?: string;
  date: string;
  installmentItems: {
    title: string;
    price: number;
    dueDate: string;
  }[];
  currencyId?: number;
  currencyExchange?: number;
  payer_id?: number;
  payer_type?: string; // Adjust the allowed values as per your requirement
  type: "payment" | "receive";
  profitSettings?: string;
};

export default function Footer({ id }: { id?: string | number }) {
  const isEdit = id ? true : false;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const store = useAppSelector((x) => x);
  const token = store.businessReducer.business.token;
  const [installmentId, setInstallmentId] = useState<{ id?: number | string; key?: number }>();

  const data = useFormikContext<InstallmentData>();
  const { defCur } = useCurrency();
  const currency = data.values.currency?.en_title || defCur.en_title;
  const payable = data.values.installmentRows?.map((x) => x.price || 0).reduce((a, b) => a + b);

  function transformArray(array: any) {
    return array.map((item: any) => {
      const { title, price, date: dueDate } = item;
      return { title, price, dueDate };
    });
  }

  function handleSubmit(mode: "save&print" | "save") {
    const isValid = installmentSchema.safeParse(data.values);

    if (!isValid.success) {
      dispatch(appSetAlert("موارد ضروری را وارد کنید", "error"));
      return;
    }

    // const newInstallments: InstallmentData[] = [...(store.installmentReducer.installments2 || [])];
    // dispatch(setInstallments2(newInstallments.push({ id: shortid.generate(), ...data.values })));
    // navigate("/installments/new");
    const {
      description,
      prePay,
      prePayType = "percent",
      totalPrice,
      totalProfit,
      installmentsCount,
      installmentsGap,
      installmentsGapType = "month",
      date,
      penaltyGap,
      penaltyGapType = "month",
      penaltyRate,
      penaltyRateType = "percent",
      installmentRows,
      type = "person",
      personId,
      factorId,
      tab = 0,
    } = data.values;
    const prepayment = prePayType === "currency" ? prePay || 0 : (totalPrice ?? 0) * ((prePay || 0) / 100);
    let serverData: ServerDataProps = {
      description: description ?? "",
      quantity: installmentsCount ?? 0,
      totalPaid: totalPrice ?? 0,
      date: date ?? "",
      installmentItems: transformArray(installmentRows),
      // currencyId: 1,
      // currencyExchange: 1,

      type: tab === 0 || undefined ? "receive" : "payment",
    };
    if (prePay) {
      serverData.prepayment = prepayment;
    }
    if (totalProfit) {
      serverData.profit = totalProfit;
    }
    if (installmentsGap && installmentsGapType) {
      if (installmentsGapType === "month") {
        serverData.interval = installmentsGap * 30;
      } else if (installmentsGapType === "year") {
        serverData.interval = installmentsGap * 365;
      } else {
        serverData.interval = installmentsGap;
      }
    }

    if (penaltyRate && penaltyGap) {
      serverData.lateFeesRate = penaltyRate;
      serverData.LateFeesRateType = penaltyRateType === "currency" ? "price" : penaltyRateType;
      if (penaltyGapType === "month") {
        serverData.LateFeesDay = penaltyGap * 30;
      } else if (penaltyGapType === "year") {
        serverData.LateFeesDay === penaltyGap * 360;
      } else {
        serverData.LateFeesDay = penaltyGap;
      }
    }

    serverData.payer_type = type === undefined ? "person" : type;

    if (personId) {
      serverData.payer_id = personId;

      serverData.type = tab === 0 || undefined ? "receive" : "payment";
    }
    if (factorId) {
      serverData.payer_id = factorId;
      // serverData.payer_type = type;
      serverData.type = tab === 0 || undefined ? "receive" : "payment";
    }
    serverData.profitSettings = data.values ? JSON.stringify(data.values) : "[]";
    if (isEdit) {
      dispatch(apiUpdateInstallment(id, serverData, token, navigate, mode === "save" ? undefined : (res: any) => {
        setInstallmentId({ id, key: Math.random() })
        navigate("/installments");
      }));
    } else {
      dispatch(apiSaveInstallment(serverData, token, navigate, mode === "save" ? undefined : (res: any) => {
        setInstallmentId({ id:res.data.data.id, key: Math.random() })
        navigate("/installments");
      }));
    }
  }

  return (
    <div className="z-[3] sticky bottom-0 mt-20 flex flex-wrap items-center justify-between w-full gap-6 p-4 bg-white rounded-md shadow-proportional">
      <div className="flex items-center gap-4">
        <span className="pl-6 border-l md:px-6 border-slate-400">مبلغ کل بازپرداخت</span>
        <div className="flex items-center gap-2">
          <span className="font-bold">{formatPrice(payable || 0)}</span>
          <span className="text-dark-3">{currency}</span>
        </div>
      </div>
      <div >
        <BasicButton className="ml-4 mr-4" variant="contained" onClick={() => handleSubmit("save")}>
          <span>{isEdit ? "ثبت تغییرات" : "ثبت نهایی"}</span>
        </BasicButton>
        <BasicButton variant="contained" onClick={() => handleSubmit("save&print")}>
          <span>{isEdit ? "ثبت تغییرات و چاپ" : "ثبت نهایی و چاپ"}</span>
        </BasicButton>
        {installmentId && installmentId.id && (

          <PrintInstallMent autoPrint={true} installmentId={installmentId.id}
            installmentType={""} index={0} />
        )}
      </div>
    </div>
  );
}
